import React, { useEffect, useState, useRef, useCallback } from "react";
import layoutthumb from "../assets/images/main/layout-tumb2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImage,
  faArrowUpFromBracket,
  faDownload,
  faRotateLeft,
  faEye,
  faXmark,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Editor from "../components/Editor";
import { Button, Modal } from "react-bootstrap";
import mammoth from "mammoth"; 
import * as pdfjsLib from "pdfjs-dist";
import { saveAs } from "file-saver";
import Overlay from "../components/Overlay";
import Spinner from "react-activity/dist/Spinner";
import Swal from "sweetalert2";
import Switch from "@mui/material/Switch";
import starimg from '../assets/images/main/stars-img.png';
import leftborder from '../assets/images/leftborder.png';
import rightborder from '../assets/images/rightborder.png';
import reset_btn from '../assets/images/reset_btn.png';
import newgenerate_btn from '../assets/images/new_generatebtn.png';
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Drawer, List, ListItem, ListItemText } from '@mui/material';
import SortableList from "../components/SortableList";


pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;


const CustomizeLayout = () => {
  const navigate = useNavigate();
  const { id, slug } = useParams();
  const [layoutdata, setlayoutdata] = useState({});
  const [editorLoaded, setEditorLoaded] = useState(true);
  const [description, setdescription] = useState("");
  const layoutdataRef = useRef();
  layoutdataRef.current = layoutdata;
  const [similarlayoutdata, setsimilarlayoutdata] = useState([]);
  const similarlayoutdataRef = useRef();
  similarlayoutdataRef.current = similarlayoutdata;

  const [showpreviewmodal, setshowpreviewmodal] = useState(false);
  const [showloding, setshowloading] = useState(false);
  const [previewloading, setpreviewloading] = useState(false);
  const [fileloading, setfileloading] = useState(false);

  const fileInputRef = useRef(null);

  const [file, setFile] = useState(null);
  const [ppturl, setppturl] = useState("");

  const [isgenerated, setisgenerated] = useState(false);
  const [checked, setChecked] = useState(false);

  const [resultarr, setresultarr] = useState({withoutai: "", withai: ""});
  const resultarrRef = useRef(null);
  resultarrRef.current = resultarr;

  const [switchtext, setswitchtext] = useState("owntext");
  const switchtextRef = useRef(null);
  switchtextRef.current = switchtext;

  const [savedlayoutsarr, setsavedlayoutsarr] = useState([]);
  const savedlayoutsarrRef = useRef([]);
  savedlayoutsarrRef.current = savedlayoutsarr;

  const savedlayouts = useSelector((store) => store.userReducer.savedlayouts);
  const dispatch = useDispatch(); 

  const [open1, setOpen1] = useState(false);

  // Search Layout
  const [searchtext, setsearchtext] = useState("");

  const clearsearchtext = () => {
    setsearchtext("");
}

const toggleDrawer1 = (state) => {
  setOpen1(state);
};

const handlerespfunc = useCallback((t) => {
      console.log('handlerespfunc t >>', t);
    var newarr = t(savedlayoutsarrRef?.current);
    setsavedlayoutsarr(newarr);
    dispatch({ type: "savedlayouts", payload: newarr });
    }, []);

const removeLayoutfunc = useCallback((t) => {
      var newarr = savedlayoutsarrRef?.current.filter((item) => item.id !== t);
      setsavedlayoutsarr(newarr);
      dispatch({ type: "savedlayouts", payload: newarr });
    }, [])

    const handlegenerateppt = async() => {
      if(savedlayoutsarrRef?.current?.length > 0) {
        setpreviewloading(true);
        var prevdata = savedlayoutsarrRef?.current;
        var prevarr = [];
        for(var i = 0; i < prevdata?.length; i++) {
          prevarr.push(prevdata[i]?.ppturl);
        }
        const headers = {
          headers: {
              'Content-Type': 'application/json'
          }
        }
        var data = {
          "ppt_paths": prevarr
        }
        let resp = await axios
              .post("https://www.theinkorporated.com/api/consolidate-slides", data, headers)
              .then((res) => {
                var prevdata = res?.data;
                window.open(prevdata?.output_path);
                setpreviewloading(false);
              }).catch((err) => {
                alert(err.message)
                setpreviewloading(false);
              })
              setpreviewloading(false);
      } else {

      }
      
    }

  const handleDivClick = () => {
    fileInputRef.current.click(); // programmatically trigger input click
  };

 const extractTextFromFile = (file) => {
    const fileType = file.type;
  
    if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      // Handle DOCX
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const arrayBuffer = e.target.result;
            const result = await mammoth.extractRawText({ arrayBuffer });
            resolve(result?.value || "");
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
  
    } else if (fileType === "application/pdf") {
      // Handle PDF
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const typedArray = new Uint8Array(e.target.result);
            const pdf = await pdfjsLib.getDocument(typedArray).promise;
  
            let text = "";
            for (let i = 1; i <= pdf.numPages; i++) {
              const page = await pdf.getPage(i);
              const content = await page.getTextContent();
              const pageText = content.items.map((s) => s.str).join(" ");
              text += pageText + "\n";
            }
  
            resolve(text);
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    }
  
    return ""; // fallback
  }

  const handleFileChange = async(event) => {
    if (event.target.files.length > 0) {
      setfileloading(true);
      console.log("Selected file:", event.target.files[0]);
      const file = event.target.files[0];
      console.log('file >>', file);

      const fileType = file.type;
      console.log('fileType >>', fileType);

      const extractedtext = await extractTextFromFile(file);
      console.log("Final Extracted Text1 >>>", extractedtext);
      setdescription(extractedtext);

      // reset the file input
  event.target.value = "";


      setfileloading(false);

    //   var ppturl = assetsUrl + layoutdataRef.current?.pptfile;
    // var imageurl = assetsUrl + layoutdataRef.current?.image;
    // var data = {
    //   content: extractedtext,
    //   fileUrl: ppturl,
    //   imageUrl: imageurl
    // }
    // console.log('data >>', data)
    //   const headers = {
    //   headers: {
    //       'Content-Type': 'application/json'
    //   }
    // }

    // let resp = await axios
    //         .post("https://d2pptxfastapi.onrender.com/generate-ppt", data, headers)
    //         .then((res) => {
    //           var prevdata = res?.data;
    //           console.log('prevdata >>', prevdata);
    //           if(prevdata?.file_url) {
    //             setppturl(prevdata?.file_url);
    //             setshowpreviewmodal(true);
    //             setfileloading(false);
    //           } else {
    //             alert('Something went wrong!! Please try again.')
    //             setfileloading(false);
    //           }
              
    //         }).catch((err) => {
    //           alert(err.message)
    //           setfileloading(false);
    //         })
    //         setfileloading(false);

  } else {
    console.log('no file >>');
  }
  };

  const fetchlayouts = async(text) => {
    var data = {
        text: text
    }
  let resp = await axios
        .post(apiUrl + "findlayouts", data)
        .then((res) => {
          if (res.data.status == "success") {
            var prevdata = res?.data?.data;
            if(prevdata?.length > 0) {
              setsimilarlayoutdata(prevdata);
            } else {
              setsimilarlayoutdata([]);
            }
            
          } else {
          }
        })
}

useEffect(() => {
        fetchlayouts(searchtext);
    }, [searchtext])


  const fetchlayoutdetails = async(id) => {
    setshowloading(true);
    var data = {
      id: id
    }
    let resp = await axios
            .post(apiUrl + "layout-detail", data)
            .then((res) => {
              if (res.data.status == "success") {
                var prevdata = res?.data?.data;
                if(Object.keys(prevdata)?.length > 0) {
                  setlayoutdata(prevdata);
                } else {
                  setlayoutdata([]);
                }
                if(res?.data?.similarlayouts?.length > 0) {
                  setsimilarlayoutdata(res?.data?.similarlayouts);
                } else {
                  setsimilarlayoutdata([]);
                }
                setshowloading(false);
                
              } else {
                setshowloading(false);
              }
            })
            setshowloading(false);
  }

  const handleFileChange1 = (e) => {
    setFile(e.target.files[0]);
  };

  const testuploadppt = async() => {
    if (!file) {
      // setMessage("Please select a PPT file first.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file); // "ppt" should match your API field name
    try {
      const response = await axios.post("https://snapglobaleservices.com/aranca/apibackend/apis/upload-ppt", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log('response data >>', response);

      // setMessage("Upload successful: " + response.data.message);
    } catch (error) {
      // setMessage("Upload failed: " + error.message);
    }
  }

  const handleconfirm = () => {
    // Swal.fire({
    //   title: "",
    //   text: "Do you want to rewrite this content with AI?",
    //   icon: "question",
    //   showCancelButton: true,
    //   confirmButtonText: "Yes",
    //   cancelButtonText: "No",
    //   width: '400px',
    //   confirmButtonColor: "#28a745",
    //   cancelButtonColor: "#d33",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     // user clicked Yes
    //     // console.log("Rewriting content...");
    //     handleclickpreview(true);
    //   } else if (result.dismiss === Swal.DismissReason.cancel) {
    //     // user clicked No
    //     // console.log("Cancelled");
    //     handleclickpreview(false);
    //   }
    // });
    console.log('checked >>', checked);
    if(description) {
      if(checked) {
        handleclickpreview(true);
      } else {
        handleclickpreview(false);
      }
    } else {
      alert('Content cannot be empty')
    }
    

  }

  const handlecustomswictchange = (name) => {
    var prevarr = resultarrRef?.current;
    if(name == "owntext") {
      // swithing to withoutAI beacuse current is true;
      if(prevarr['withoutai']) {
        setswitchtext(name);
        setChecked(false);
      } else {
        handleclickpreview(false);
      }
    } else {
      // swithing to withAI beacuse current is false;
      if(prevarr['withai']) {
        setswitchtext(name);
        setChecked(true);
      } else {
        console.log('calling for withai >>>');
        handleclickpreview(true);
      }
    }
  }

  const handleclickpreview = async(isrewrite) => {
    // var ppturl = assetsUrl + "ppt/" + layoutdataRef.current?.pptfile;
    var ppturl = assetsUrl + layoutdataRef.current?.pptfile;
    var imageurl = assetsUrl + layoutdataRef.current?.image;
    setpreviewloading(true);
    
    var data = {
      content: description,
      fileUrl: ppturl,
      imageUrl: imageurl,
      rewriteWithAi: isrewrite
    }
    console.log('data >>', data)
      const headers = {
      headers: {
          'Content-Type': 'application/json'
      }
    }

    let resp = await axios
            .post("https://www.theinkorporated.com/api/generate-ppt", data, headers)
            .then((res) => {
              var prevdata = res?.data;
              console.log('prevdata >>', prevdata);
              if(prevdata?.file_url) {
                setpreviewloading(false);

                if(isrewrite == true || isrewrite == "true") {
                  var prevarr = resultarrRef?.current;
                  prevarr['withai'] = prevdata?.file_url;
                  setresultarr(prevarr);
                  setswitchtext('aitext');
                  setChecked(true);
                } else {
                  var prevarr = resultarrRef?.current;
                  prevarr['withoutai'] = prevdata?.file_url;
                  setresultarr(prevarr);
                  setswitchtext('owntext');
                  setChecked(false);
                }

                // setppturl(prevdata?.file_url);

                // setshowpreviewmodal(true);
                setisgenerated(true);
              } else {
                setpreviewloading(false);
                alert(prevdata?.error)
              }
              
            }).catch((err) => {
              alert(err.message)
              setpreviewloading(false);
            })
            setpreviewloading(false);

  //   const headers = {
  //     headers: {
  //         'responseType': "blob"
  //     }
  // }
    // var data = {
    //   "fileUrl": "http://upskillscertifications.com/aranca/ppt/4_process.pptx",
    //   "content": "<p><strong>Recruitment Process Improvement</strong></p><p>Time to Hire: Reduced time to hire is achieved by using the reduced time delays in communication</p><p>Cost Per Hire: Managers and recruitment specialists should be able to leverage a Talent Pool.</p><p>Candidate Quality: Electronic candidate screening as part of the online application process</p><p>Recruitment Efficiency: Manual processes need to be automated &amp; reduce the need for printed documentation.</p>",
    //   "imageUrl": "https://upskillscertifications.com/aranca/images/4_process.png"
    // }

    // let resp = await axios
    //         .post("https://d2pptxfastapi.onrender.com/generate-ppt", data, { responseType: "blob" })
    //         .then((res) => {
    //           console.log('res >>', res);
    //           // const blob1 = res?.blob();
    //           // saveAs(blob1, "presentation.pptx");

    //           const fileURL = URL.createObjectURL(res.data);
    //           console.log('fileURL >>', fileURL);
    //           setppturl(fileURL);
    //           setshowpreviewmodal(true);

    //           // const blob = new Blob([res.data], {
    //           //   type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    //           // });
          
    //           // saveAs(blob, "hello_world.pptx");


    //         })
    // console.log('data >>', data);


    
  }

  const handleclickonsave = () => {
    
    // return;
    // dispatch({ type: "savedlayouts", payload: [] });
    // return;
    if(structuredClone(savedlayoutsarrRef.current)) {
      var prevdata = structuredClone(savedlayoutsarrRef.current);
    } else {
      var prevdata = [];
    }
   
    // console.log('prevdata >>', prevdata);
    var newobj = {};
    console.log('layoutdataRef.current?.image >>', layoutdataRef.current);
    newobj['id'] = prevdata?.length + 1;
    newobj['imageurl'] = assetsUrl + layoutdataRef.current?.image; // save image

    // Save ppt file
    // console.log('resultarrRef?.current >>>', resultarrRef?.current);
    if (isgenerated) {
      var url = "";
      if (checked) {
        if(resultarrRef?.current['withai']) {
          url = resultarrRef?.current['withai'];
          newobj['ppturl'] = url;
          // window.open(url);
        } else {
          alert('Unable to save')
          return;
        }
      } else {
        if(resultarrRef?.current['withoutai']) {
          url = resultarrRef?.current['withoutai'];
          newobj['ppturl'] = url;
          // window.open(url);
        } else {
          alert('Unable to save');
          return;
        }
      }
     
    } else {
      var url = "";
      url = assetsUrl + layoutdataRef.current?.pptfile;
      newobj['ppturl'] = url;
      // window.open(url);
    }
    
    console.log('newobj >>', newobj);
    prevdata.push(newobj);
    dispatch({ type: "savedlayouts", payload: prevdata });
    toast.success('Saved successfully !!');
    window.scrollTo({
      top: 800,
      behavior: 'smooth', // optional smooth scroll
    });
  }

  const openrightdrawer = () => {
    setOpen1(true);
  }

  const handledownload = () => {
    // if (!previewloading && !isgenerated) {
      if (isgenerated) {
      var url = "";
      if (checked) {
        if(resultarrRef?.current['withai']) {
          url = resultarrRef?.current['withai'];
          window.open(url);
        } else {
          alert('Unable to download')
        }
      } else {
        if(resultarrRef?.current['withoutai']) {
          url = resultarrRef?.current['withoutai'];
          window.open(url);
        } else {
          alert('Unable to download')
        }
      }
     
    } else {
      var url = "";
      url = assetsUrl + layoutdataRef.current?.pptfile;
      window.open(url);
      // alert('Inititae download')
    }
    
  }

  useEffect(() => {
    fetchlayoutdetails(id);
  }, [id]);

  useEffect(() => {
    setsavedlayoutsarr(savedlayouts);
    if (savedlayoutsarrRef?.current?.length > 0) {
      if (savedlayoutsarrRef?.current?.length == savedlayouts?.length) {
      } else {
        setOpen1(true);
      }
    } else {
    }
  }, [savedlayouts]);

  console.log('layout data >>>', layoutdataRef.current)
  console.log('resultarrRef.current >>', resultarrRef.current);
  console.log('checked >>', checked);

  return (
    <>
     <div className="homepage-layout">
      <ToastContainer
        position="top-right"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
      <Overlay showloader={showloding} />
      <div className="custom-section1">
        {Object.keys(layoutdataRef.current)?.length > 0 ? (
          <>
            {/* <div className="howitworkstitlediv customizelayouthowitworksborder">
              <div className="thinborder"></div>
              <div className="thindotdiv">
                <div className="thindot"></div>
              </div>
              <div className="bordertitlediv">
                <p>Customize the layout</p>
              </div>
              <div className="thindotdiv">
                <div className="thindot thindot1"></div>
              </div>
              <div className="thinborder"></div>
            </div> */}
            <div className="container">
              <div className="howitworkstitlediv customizelayouthowitworksborder">
                <div className="newthinleftborder">
                  <img src={leftborder} className="newleftborder" />
                </div>
                <div className="bordertitlediv">
                  <p>Customize Layout</p>
                </div>
                <div className="newthinrightborder">
                  <img src={rightborder} className="newleftborder" />
                </div>
              </div>
            </div>
            {/* <div className="container">
              <div className="row">
                <div className="col-12 col-md-7">
                  {previewloading ? (
                    <div className="sampletemplatedivforloader">
                      <Spinner
                        color="#000"
                        size={22}
                        className="previewloader"
                      />
                    </div>
                  ) : (
                    <div className="sampletemplatediv">
                      {isgenerated ? (
                        checked ? ( // withAI
                          resultarrRef.current["withai"] ? (
                            <iframe
                              src={`https://docs.google.com/gview?url=${resultarrRef.current["withai"]}&embedded=true`}
                              style={{
                                width: "100%",
                                height: "450px",
                                border: "none",
                              }}
                              title="PPT Preview"
                            ></iframe>
                          ) : (
                            <img
                              src={assetsUrl + layoutdataRef.current?.image}
                            />
                          )
                        ) : // without AI
                        resultarrRef.current["withoutai"] ? (
                          <iframe
                            src={`https://docs.google.com/gview?url=${resultarrRef.current["withoutai"]}&embedded=true`}
                            style={{
                              width: "100%",
                              height: "450px",
                              border: "none",
                            }}
                            title="PPT Preview"
                          ></iframe>
                        ) : (
                          <img src={assetsUrl + layoutdataRef.current?.image} />
                        )
                      ) : (
                        <img src={assetsUrl + layoutdataRef.current?.image} />
                      )}
                    </div>
                  )}

                  <div className="newdownloadrow">
                    {isgenerated ? (
                      <div className="newtogglediv">
                        <div
                          className={
                            switchtextRef.current == "owntext"
                              ? "newtoggletext activetogglebg"
                              : "newtoggletext"
                          }
                          onClick={() => {
                            if (switchtextRef.current == "owntext") {
                            } else {
                              handlecustomswictchange("owntext");
                            }
                          }}
                        >
                          Use my version
                        </div>
                        <div
                          className={
                            switchtextRef.current == "aitext"
                              ? "newtoggletext activetogglebg"
                              : "newtoggletext"
                          }
                          onClick={() => {
                            if (switchtextRef.current == "aitext") {
                            } else {
                              handlecustomswictchange("aitext");
                            }
                          }}
                        >
                          Rewrite with AI
                        </div>
                      </div>
                    ) : (
                      <div></div>
                    )}
                    <div
                      className="downloadbtn"
                      onClick={() => {
                        handledownload();
                      }}
                    >
                      <p>Download</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-5">
                  <div className="custom-edit-layout">
                    <div className="custom-edit-layout-body">
                      <Editor
                        name="description"
                        value={description}
                        onChange={(t) => {
                          console.log("t >>", t);
                          setdescription(t);
                        }}
                        editorLoaded={editorLoaded}
                      />
                    </div>
                  </div>

                  <div className="newbtnsrow">
                    <div className="download-sample-row">
                      <div
                        className="custom-uploadbtndiv"
                        onClick={handleDivClick}
                      >
                        {fileloading ? (
                          <Spinner
                            color="#fff"
                            size={14}
                            className="previewloader"
                          />
                        ) : (
                          <div className="uploadbtninsidediv">
                            <FontAwesomeIcon
                              icon={faArrowUpFromBracket}
                              className="custom-uploadicon"
                              style={{ fontSize: 16, color: "#fff" }}
                            />
                            <p>Upload Document</p>
                          </div>
                        )}
                      </div>
                      <input
                        type="file"
                        accept=".pdf,.docx"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      ></input>
                    </div>
                    <div
                      className="custom-resetbtn "
                      style={{ marginLeft: "auto" }}
                      onClick={() => {
                        setdescription("");
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faRotateLeft}
                        className="custom-reseticon"
                        style={{ color: "#fff" }}
                      />
                      <p>Reset</p>
                    </div>
                    <div
                      className="custom-resetbtn"
                      style={{ backgroundColor: "#198754", minWidth: 116 }}
                      onClick={() => {
                        if (previewloading) {
                        } else {
                          handleconfirm();
                        }

                        // testuploadppt();
                      }}
                    >
                      {previewloading ? (
                        <Spinner
                          color="#fff"
                          size={12}
                          className="previewloader"
                        />
                      ) : (
                        <>
                          <img src={starimg} className="start-img" />
                          <p style={{ color: "#fff" }}>Generate</p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* New Layout */}
            <div className="customizelayoutmainrow">
              <div className="container">
                <div className="customizelayoutrow">
                  <div className="customizelayoutleftdiv">
                    {previewloading ? (
                      <div className="sampletemplatedivforloader">
                        <Spinner
                          color="#000"
                          size={22}
                          className="previewloader"
                        />
                      </div>
                    ) : (
                      <div className="sampletemplatediv">
                        {isgenerated ? (
                          checked ? ( // withAI
                            resultarrRef.current["withai"] ? (
                              <iframe
                                src={`https://docs.google.com/gview?url=${resultarrRef.current["withai"]}&embedded=true`}
                                style={{
                                  width: "100%",
                                  height: "450px",
                                  border: "none",
                                }}
                                title="PPT Preview"
                              ></iframe>
                            ) : (
                              <img
                                src={assetsUrl + layoutdataRef.current?.image}
                              />
                            )
                          ) : // without AI
                          resultarrRef.current["withoutai"] ? (
                            <iframe
                              src={`https://docs.google.com/gview?url=${resultarrRef.current["withoutai"]}&embedded=true`}
                              style={{
                                width: "100%",
                                height: "450px",
                                border: "none",
                              }}
                              title="PPT Preview"
                            ></iframe>
                          ) : (
                            <img
                              src={assetsUrl + layoutdataRef.current?.image}
                            />
                          )
                        ) : (
                          <img src={assetsUrl + layoutdataRef.current?.image} />
                        )}
                      </div>
                    )}
                    <div className="newdownloadrow">
                      <div className="newtogglediv">
                        <div
                          className={
                            switchtextRef.current == "owntext"
                              ? "newtoggletext activetogglebg"
                              : "newtoggletext"
                          }
                          onClick={() => {
                            if (switchtextRef.current == "owntext") {
                            } else {
                              handlecustomswictchange("owntext");
                            }
                          }}
                        >
                          Use my version
                        </div>
                        <div
                          className={
                            switchtextRef.current == "aitext"
                              ? "newtoggletext activetogglebg"
                              : "newtoggletext"
                          }
                          onClick={() => {
                            if (switchtextRef.current == "aitext") {
                            } else {
                              handlecustomswictchange("aitext");
                            }
                          }}
                        >
                          Rewrite with AI
                        </div>
                      </div>
                      <div
                        className="downloadbtn savepptbtn"
                        onClick={() => {
                          // handleclickonsave();
                          handleclickonsave();
                        }}
                      >
                        <p>Add Slide</p>
                      </div>
                      <div
                        className="downloadbtn"
                        style={{ marginLeft: 0 }}
                        onClick={() => {
                          // handledownload();
                          // handleclickonsave();
                          openrightdrawer()
                        }}
                      >
                        <p>Download</p>
                      </div>
                    </div>
                  </div>

                  <div className="customizelayoutrightdiv">
                    <div className="custom-edit-layout-body">
                      <div className="customeditortoprow">
                        <div
                          className="toprowuploadbtn"
                          onClick={handleDivClick}
                        >
                          {fileloading ? (
                            <Spinner
                              color="#fff"
                              size={14}
                              className="previewloader"
                            />
                          ) : (
                            <p>Upload File</p>
                          )}
                        </div>
                        <input
                          type="file"
                          accept=".pdf,.docx"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        ></input>
                      </div>
                      <div className="customeditortopinputdiv">
                        <textarea
                          value={description}
                          onChange={(t) => {
                            setdescription(t.target.value);
                          }}
                          className="form-control customeditortopinput"
                          placeholder="Paste Your Content Here"
                        ></textarea>
                      </div>
                    </div>
                    <div className="newbtnsrow">
                      {/* <div className="download-sample-row">
                      <div
                        className="custom-uploadbtndiv"
                        onClick={handleDivClick}
                      >
                        {fileloading ? (
                          <Spinner
                            color="#fff"
                            size={14}
                            className="previewloader"
                          />
                        ) : (
                          <div className="uploadbtninsidediv">
                            <FontAwesomeIcon
                              icon={faArrowUpFromBracket}
                              className="custom-uploadicon"
                              style={{ fontSize: 16, color: "#fff" }}
                            />
                            <p>Upload Document</p>
                          </div>
                        )}
                      </div>
                      <input
                        type="file"
                        accept=".pdf,.docx"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      ></input>
                    </div> */}
                      {/* <div
                      className="custom-resetbtn "
                      style={{ marginLeft: "auto" }}
                      onClick={() => {
                        setdescription("");
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faRotateLeft}
                        className="custom-reseticon"
                        style={{ color: "#fff" }}
                      />
                      <p>Reset</p>
                    </div> */}
                      <div
                        className="newcustom-resetbtndiv"
                        // style={{ marginLeft: "auto" }}
                        onClick={() => {
                          setdescription("");
                        }}
                      >
                        <img src={reset_btn} className="newreset-btnimg" />
                      </div>
                      <div
                        className="custom-resetbtn"
                        style={{ backgroundColor: "#198754", minWidth: 116 }}
                        onClick={() => {
                          if (previewloading) {
                          } else {
                            handleconfirm();
                          }

                          // testuploadppt();
                        }}
                      >
                        {previewloading ? (
                          <Spinner
                            color="#fff"
                            size={12}
                            className="previewloader"
                          />
                        ) : (
                          <>
                            <img src={starimg} className="start-img" />
                            <p style={{ color: "#fff" }}>Generate</p>
                          </>
                        )}
                      </div>
                      {/* {
                      previewloading ?
                      <div
                      className="custom-resetbtn"
                      style={{ backgroundColor: "#198754", minWidth: 116 }}
                    >
                       <Spinner
                          color="#fff"
                          size={12}
                          className="previewloader"
                        />
                    </div> 
                    
                    : 
                    <div
                      className="newcustom-resetbtndiv"
                      style={{marginLeft: 15}}
                      onClick={() => {
                        handleconfirm();
                      }}
                    >
                      <img src={newgenerate_btn} className="newreset-btnimg" />
                    </div>
                    } */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {similarlayoutdataRef.current?.length > 0 ? (
              <>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                {/* <div className="howitworkstitlediv">
                  <div className="thinborder"></div>
                  <div className="thindotdiv">
                    <div className="thindot"></div>
                  </div>
                  <div className="bordertitlediv">
                    <p>Similar layouts</p>
                  </div>
                  <div className="thindotdiv">
                    <div className="thindot thindot1"></div>
                  </div>
                  <div className="thinborder"></div>
                </div> */}
                <div className="container">
                  <div className="howitworkstitlediv similarlayoutsdiv">
                    <div className="newthinleftborder">
                      <img src={leftborder} className="newleftborder" />
                    </div>
                    <div className="bordertitlediv">
                      <p>Similar layouts</p>
                    </div>
                    <div className="newthinrightborder">
                      <img src={rightborder} className="newleftborder" />
                    </div>
                  </div>
                </div>
                <div className="customizelayout-searchmaindiv">
                  <div className="section1searchdiv">
                    {searchtext?.length > 0 ? (
                      <div
                        className="searchclearicon"
                        onClick={() => {
                          clearsearchtext();
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faXmark}
                          className="section1icon1"
                        />
                      </div>
                    ) : null}
                    <div className="searchicondivnew">
                      <img src={starimg} className="start-img" />
                      <p>Search</p>
                    </div>
                    <input
                      value={searchtext}
                      onChange={(t) => {
                        setsearchtext(t.target.value);
                      }}
                      type="text"
                      className="searchinputdiv"
                    />
                  </div>
                </div>
                <div className="container">
                  <div className="similar-layout-section">
                    {/* <p className="custom-section1-head">Similar layouts</p> */}
                    <div className="row pplayoutsrow">
                      {similarlayoutdataRef.current?.map((item, index) => {
                        if (item?.id == id) {
                        } else {
                          return (
                            <div
                              className="col-12 col-sm-6 col-md-4 mb-4"
                              onClick={() => {
                                setisgenerated(false);
                                setresultarr({ withoutai: "", withai: "" });
                                navigate(
                                  "/customize-layout" +
                                    "/" +
                                    item?.id +
                                    "/" +
                                    item?.slug
                                );
                              }}
                              key={index}
                            >
                              {/* <img
                          src={assetsUrl + "images/" + item?.image}
                          className="layout-tumb"
                        /> */}
                              <img
                                src={assetsUrl + item?.image}
                                className="layout-tumb"
                              />
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </>
        ) : null}

        {/*Add modal */}
        <Modal
          show={showpreviewmodal}
          onHide={() => setshowpreviewmodal(false)}
          size="lg"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Preview PPT</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div
                style={{
                  width: "100%",
                  height: "400",
                  border: "1px solid #ddd",
                }}
              >
                {/* <iframe
                title="ppt"
                src={
                  "https://docs.google.com/gview?url=https://upskillscertifications.com/ppt/1755973030.pptx&embedded=true"
                }
                width="100%"
                height="400"
                allowFullScreen
              /> */}
                <iframe
                  src={`https://docs.google.com/gview?url=${ppturl}&embedded=true`}
                  style={{ width: "100%", height: "600px", border: "none" }}
                  title="PPT Preview"
                ></iframe>
              </div>
              <div className="previewmodal-btnsrow">
                <div
                  className="custom-resetbtn"
                  onClick={() => {
                    setshowpreviewmodal(false);
                  }}
                >
                  <p>Cancel</p>
                </div>
                <div
                  className="custom-resetbtn"
                  style={{ backgroundColor: "#198754" }}
                  onClick={() => {
                    handledownload(ppturl);
                  }}
                >
                  <p style={{ color: "#fff" }}>Download</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
      <div className="right-arrow-div">
        <div
          className="righticonbox"
          onClick={() => {
            setOpen1(true);
          }}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            className="leftchevicon"
            style={{ color: "#fff", fontSize: 18 }}
          />
        </div>
      </div>
      <Drawer
        anchor="right"
        open={open1}
        onClose={() => {
          toggleDrawer1(false);
        }}
      >
        <List sx={{ width: 280 }}>
          <div className="savesidebar">
            <div
              className="savesidebar-closediv"
              onClick={() => {
                toggleDrawer1(false);
              }}
            >
              <FontAwesomeIcon icon={faXmark} className="sidebariconsidebar" />
            </div>
            {
                savedlayoutsarrRef.current?.length > 0 ?
                <div className="sidebarmain">
              
                <p className="saved-layouttexts">Saved Layouts</p>
                <SortableList listarr={savedlayoutsarrRef.current} handleresp={handlerespfunc} removeLayout={removeLayoutfunc} />
                 <div
                        className="custom-resetbtn sidebar-generate-btn"
                        style={{ backgroundColor: "#198754", minWidth: 116 }}
                        onClick={() => {
                          if (previewloading) {
                          } else {
                            handlegenerateppt();
                          }
                        }}
                      >
                        {previewloading ? (
                          <Spinner
                            color="#fff"
                            size={12}
                            className="previewloader"
                          />
                        ) : (
                          <>
                            <img src={starimg} className="start-img" />
                            <p style={{ color: "#fff" }}>Download</p>
                          </>
                        )}
                      </div>
            </div> :
            <div className="sidebarmain">
              <p className="saved-layouttexts no-layouts-text">No Layouts Added</p>
            </div>
              }
            
          </div>
        </List>
      </Drawer>
    </>
   
  );
};

export default CustomizeLayout;
